import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

export default function Footer() {
  const { t } = useI18n();
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#001F3F] text-white mt-24" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-serif text-2xl mb-3 tracking-tight">
            Clinical &amp; Surgical Review
          </div>
          <div className="text-sm font-sans text-white/70 leading-relaxed max-w-md">
            {t("footer.tagline")}
          </div>
          <div className="mt-6 grid grid-cols-2 gap-3 text-xs font-sans">
            <div>
              <div className="text-[#2BA6A6] uppercase tracking-widest mb-1">{t("footer.issn")}</div>
              <div className="text-white/90">{settings?.issn_electronic || "Pending"}</div>
            </div>
            <div>
              <div className="text-[#2BA6A6] uppercase tracking-widest mb-1">{t("footer.doi_prefix")}</div>
              <div className="text-white/90">{settings?.doi_prefix || "Pending"}</div>
            </div>
            <div>
              <div className="text-[#2BA6A6] uppercase tracking-widest mb-1">{t("footer.contact")}</div>
              <div className="text-white/90 break-all">{settings?.contact_email || "editorial@csrjournal.org"}</div>
            </div>
            <div>
              <div className="text-[#2BA6A6] uppercase tracking-widest mb-1">{t("footer.website")}</div>
              <div className="text-white/90">{settings?.website || "www.csrjournal.org"}</div>
            </div>
          </div>
        </div>

        <div>
          <div className="text-xs font-sans uppercase tracking-[0.2em] text-[#2BA6A6] font-semibold mb-4">
            {t("footer.for_authors")}
          </div>
          <ul className="space-y-2 text-sm font-sans text-white/80">
            <li><Link to="/authors" className="hover:text-[#2BA6A6]" data-testid="footer-link-authors">{t("footer.instructions")}</Link></li>
            <li><Link to="/submit" className="hover:text-[#2BA6A6]" data-testid="footer-link-submit">{t("footer.submit")}</Link></li>
            <li><Link to="/peer-review" className="hover:text-[#2BA6A6]" data-testid="footer-link-peer-review">{t("footer.peer_review")}</Link></li>
            <li><Link to="/ethics" className="hover:text-[#2BA6A6]" data-testid="footer-link-ethics">{t("footer.ethics")}</Link></li>
            <li><Link to="/apc" className="hover:text-[#2BA6A6]" data-testid="footer-link-apc">{t("footer.apc")}</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs font-sans uppercase tracking-[0.2em] text-[#2BA6A6] font-semibold mb-4">
            {t("footer.about")}
          </div>
          <ul className="space-y-2 text-sm font-sans text-white/80">
            <li><Link to="/about" className="hover:text-[#2BA6A6]">{t("footer.about_journal")}</Link></li>
            <li><Link to="/aims-scope" className="hover:text-[#2BA6A6]">{t("footer.aims_scope")}</Link></li>
            <li><Link to="/editorial-board" className="hover:text-[#2BA6A6]">{t("footer.editorial_board")}</Link></li>
            <li><Link to="/contact" className="hover:text-[#2BA6A6]">{t("footer.contact_page")}</Link></li>
            <li><Link to="/privacy" className="hover:text-[#2BA6A6]">{t("footer.privacy")}</Link></li>
            <li><Link to="/legal-notice" className="hover:text-[#2BA6A6]" data-testid="footer-link-legal-notice">{t("footer.legal_notice")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 py-5 text-xs font-sans text-white/60 flex flex-col md:flex-row items-center justify-between gap-2">
          <div>© {year} Clinical &amp; Surgical Review. {t("footer.rights")}</div>
          <div>{t("footer.subline")}</div>
        </div>
      </div>
    </footer>
  );
}
